module.exports = __webpack_public_path__ + "media/images/pic/testimonials/klaudia-14bd19b732b8a30a8486dec87076e9b3.webp";